import {
  DesktopLayoutBoxed,
  DesktopLayoutBoxedContent,
  Text,
} from '@kanda-libs/ks-design-library';

import { GoogleSignInButton } from 'components/auth/GoogleSignInButton';
import PageTitle from 'components/shared/PageTitle';
import useLogin from 'hooks/useLogin';

export default function Login() {
  const { signInWithGoogle } = useLogin();
  localStorage.removeItem('__ksp_visited__');

  return (
    <DesktopLayoutBoxed>
      <DesktopLayoutBoxedContent>
        <PageTitle>Login</PageTitle>
        <Text text="Login" className="mb-10 text-center text-24-28-em" />
        <GoogleSignInButton onSignIn={signInWithGoogle} />
      </DesktopLayoutBoxedContent>
    </DesktopLayoutBoxed>
  );
}
